module.exports = __webpack_public_path__ + "img/logo_mini.d5c8bf51.svg";